<template>
  <div>
    <StoryHeader v-if="asset" :asset="asset" :alt="entry.title">
      <div v-if="entry.categories" class="flex flex-row items-center space-x-4">
        <TagBtn v-if="entry.categories && entry.categories.length > 0" :to="$localeRootPath(entry.categories[0].uri)">
          {{ tagTitle }}
        </TagBtn>
        <TimeToRead
          v-if="entry.readTime"
          :read-time="entry.readTime"
          class="fluid-sm leading-tightest font-medium"
          :is-video="entry.isAVideo"
        />
      </div>
      <h1 class="lg:mt-4 mt-2 fluid-3xl leading-tightest">{{ entry.title }}</h1>
      <PublishedLine
        v-if="author"
        :author="author"
        :at="entry.postDate"
        :topic="entry.categories[0]"
        class="block my-4"
      />
    </StoryHeader>
    <ContentBlocks :entry="entry" :social-media-accounts="socialMediaAccounts" />
  </div>
</template>
<script>
import gql from 'graphql-tag';
import ContentBlocks from '@/components/common/ContentBlocks';
import { ContentBlocksMatrixFragment } from '@/components/common/ContentBlocksMatrixFragment.js';
import StoryHeader from '@/components/stories/StoryHeader';
import TagBtn from '@/components/common/TagBtn';
import PublishedLine from '@/components/article/PublishedLine';
import TimeToRead from '@/components/common/TimeToRead';

export const StoryPageFragment = gql`
  fragment StoryPageFragment on story_Entry {
    title
    headerImageOrVideo {
      url
      kind
    }
    isAVideo
    categories: storiesCategories {
      uri
      title
    }
    authorName
    readTime
    postDate
    ... on story_Entry {
      title
      seoTopics
    }
    contentBlocks {
      ...ContentBlocksMatrixFragment
    }
  }
  ${ContentBlocksMatrixFragment}
`;

export default defineNuxtComponent({
  name: 'StoryPage',
  components: {
    TimeToRead,
    ContentBlocks,
    StoryHeader,
    TagBtn,
    PublishedLine,
  },
  props: {
    entry: {
      type: Object,
      default: () => {},
    },
    socialMediaAccounts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    asset() {
      return this.entry?.headerImageOrVideo?.length ? this.entry?.headerImageOrVideo : null;
    },
    author() {
      return this.entry?.authorName ? { title: this.entry?.authorName } : null;
    },
    tagTitle() {
      return this.entry?.categories.length && this.entry?.categories[0]?.title;
    },
  },
});
</script>
